var map = {
	"./frame01_current.png": "cf38",
	"./frame01_normal.png": "50eb",
	"./frame01_stamp.png": "1660",
	"./frame02_current.png": "bba9",
	"./frame02_normal.png": "3f0c",
	"./frame02_stamp.png": "2a04",
	"./frame03_current.png": "fcee",
	"./frame03_normal.png": "989c",
	"./frame03_stamp.png": "997d",
	"./frame04_current.png": "3121",
	"./frame04_normal.png": "c09b",
	"./frame04_stamp.png": "4110",
	"./frame05_current.png": "d86f",
	"./frame05_normal.png": "d2d6",
	"./frame05_stamp.png": "3308",
	"./frame06_current.png": "2861",
	"./frame06_normal.png": "26be",
	"./frame06_stamp.png": "4485",
	"./frame07_current.png": "b3fc",
	"./frame07_normal.png": "016e",
	"./frame07_stamp.png": "91fd",
	"./frame08_current.png": "b133",
	"./frame08_normal.png": "e4d3",
	"./frame08_stamp.png": "d391",
	"./frame09_current.png": "06a8",
	"./frame09_normal.png": "6ad8",
	"./frame09_stamp.png": "69d7",
	"./frame10_current.png": "233d",
	"./frame10_normal.png": "a672",
	"./frame10_stamp.png": "0fb0",
	"./frame11_current.png": "7f22",
	"./frame11_normal.png": "7f8f",
	"./frame11_stamp.png": "a331",
	"./frame12_current.png": "6e13",
	"./frame12_normal.png": "62e4",
	"./frame12_stamp.png": "9294",
	"./frame13_current.png": "8298",
	"./frame13_normal.png": "6a19",
	"./frame13_stamp.png": "aca9",
	"./frame14_current.png": "0da9",
	"./frame14_normal.png": "64d3",
	"./frame14_stamp.png": "0c56",
	"./frame15_current.png": "2ac5",
	"./frame15_normal.png": "4632",
	"./frame15_stamp.png": "be64",
	"./frame16_current.png": "4e97",
	"./frame16_normal.png": "0a58",
	"./frame16_stamp.png": "5b5c",
	"./frame17_current.png": "e310",
	"./frame17_normal.png": "0d05",
	"./frame17_stamp.png": "dec0",
	"./frame18_current.png": "c967",
	"./frame18_normal.png": "8256",
	"./frame18_stamp.png": "077a",
	"./frame19_current.png": "2136",
	"./frame19_normal.png": "beec",
	"./frame19_stamp.png": "bdfe",
	"./frame20_current.png": "1155",
	"./frame20_normal.png": "14c3",
	"./frame20_stamp.png": "e22d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fb4f";